import React from "react";
import SearchPoc from "./components/SearchPoc/SearchPoc";
import AdobeAnalytics from "./components/analytics/AdobeAnalytics";
import { AdobePageBottom } from "./components/analytics/AdobePageBottom/AdobePageBottom";
import AnalyticsPageContext from "./components/analytics/AnalyticsPageContext";
import GenericPageView from "./components/analytics/GenericPageView/GenericPageView";
import "./App.scss";

function App() {

  return (
    <AdobeAnalytics>
      <div className="App">
        <AdobePageBottom />
        <AnalyticsPageContext
          pageName="pens-stand"
          rawPageName="Pens Stand"
          pageType="pens-stand"
        />
        <GenericPageView />
        <SearchPoc />
      </div>
    </AdobeAnalytics>
  );
}

export default App;
